import { showToast } from './toast';

export type ConfirmRequest = {
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'primary' | 'danger';
};

type ConfirmRequestDetail = ConfirmRequest & {
  resolve: (confirmed: boolean) => void;
};

export type TextInputRequest = {
  title: string;
  description?: string;
  initialValue?: string;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  confirmText?: string;
  cancelText?: string;
  variant?: 'primary' | 'danger';
};

type TextInputRequestDetail = TextInputRequest & {
  resolve: (value: string | null) => void;
};

export type CheckboxChoiceOption = {
  id: string;
  label: string;
  description?: string;
  defaultChecked?: boolean;
  disabled?: boolean;
};

export type CheckboxChoiceRequest = {
  title: string;
  description?: string;
  options: CheckboxChoiceOption[];
  allowEmptySelection?: boolean;
  confirmText?: string;
  cancelText?: string;
  variant?: 'primary' | 'danger';
};

type CheckboxChoiceRequestDetail = CheckboxChoiceRequest & {
  resolve: (value: Record<string, boolean> | null) => void;
};

export function showInfo(message: string) {
  showToast({ message, variant: 'info' });
}

export function showSuccess(message: string) {
  showToast({ message, variant: 'success' });
}

export function showWarning(message: string) {
  showToast({ message, variant: 'warning' });
}

export function showError(message: string) {
  showToast({ message, variant: 'error' });
}

export function requestConfirmation(request: ConfirmRequest): Promise<boolean> {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent<ConfirmRequestDetail>('app:confirm', {
      detail: {
        ...request,
        resolve
      }
    }));
  });
}

export function requestTextInput(request: TextInputRequest): Promise<string | null> {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent<TextInputRequestDetail>('app:text-input', {
      detail: {
        ...request,
        resolve
      }
    }));
  });
}

export function requestCheckboxChoice(request: CheckboxChoiceRequest): Promise<Record<string, boolean> | null> {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent<CheckboxChoiceRequestDetail>('app:checkbox-choice', {
      detail: {
        ...request,
        resolve
      }
    }));
  });
}
